module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "generated-style",
    attrs: {
      "id": "weitgmefm"
    }
  }, [_c('p', {
    staticClass: "chapter-head",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/WEITGMeACK"
    }
  }, [_c('span', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/WEITGMePRO"
    }
  }, [_c('span', [_vm._v("Prologue")])])]), _vm._v(" "), _c('p', {
    staticClass: "Parthead",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART I")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER1"
    }
  }, [_c('span', [_vm._v("1 Krewe of da Mansion")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER2"
    }
  }, [_c('span', [_vm._v("2 Run, Forest, Run!")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("3 The Middleton Drug Store Shootout")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("4 The Baton Rouge Criminal Justice System")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("5 The Plea")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("6 Louisiana State Peniversity at Angola")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("7 The Fighting Inmate Lawyer")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("8 Round One: Saint vs. the Criminal Justice System")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("9 Round Two: Short and Sweet")])])]), _vm._v(" "), _c('p', {
    staticClass: "Parthead",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART II")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("10 Leaving That Place, Angola")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("11 Voices and Echoes at the Mansion")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("12 Louisiana’s Slavery Not Abolished—Just Hidden")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("13 Convict Chefs and Butlers—Louisiana’s Best")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("14 The Setup")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("15 The Amazing Ball Runner")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("16 Boxing, Tea Parties, Chess, and Football")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("17 Serious Underlying Ramifications")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("18 The First Couple on Trial")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("19 Fifteen Months of Building Pressure")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTER20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("20 Listening to a Still Small Voice")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterLink",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/WEITGMeCHAPTEREpilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Epilogue")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa8cef8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Contents.vue
// module id = 72
// module chunks = 0